import React from "react";
import Select from "react-select";

import { filterSelectStyles } from "../../../components/FilterSimple";
import { getBillingCompanyLabel } from "../billingCompany";

const ALL_OPTION = { label: 'Todas as empresas', value: '' };

/**
 * Seletor de empresa de faturamento do cabeçalho das listas do financeiro.
 *
 * A regra de esconder com um CNPJ só vive aqui dentro, e não em cada tela, para
 * não haver como esquecer de aplicá-la numa delas.
 */
export const BillingCompanyFilter = ({ billingCompanies, value, change }) => {
    if (billingCompanies.length < 2) {
        return null;
    }

    const options = [
        ALL_OPTION,
        ...billingCompanies.map(company => ({ label: getBillingCompanyLabel(company), value: company.id })),
    ];

    return (
        <div className="filter-select">
            <Select
                placeholder="Escolha uma empresa..."
                options={options}
                value={options.find(option => option.value === (value || '')) ?? ALL_OPTION}
                onChange={option => change(option.value)}
                styles={filterSelectStyles}
                isSearchable={false}
            />
        </div>
    );
};

export default BillingCompanyFilter;
